import { PatchCheckFill, ExclamationTriangleFill, ShieldCheck } from "react-bootstrap-icons";
import { conditionLabel, inspectedLabel } from "./format";
import "./CarStatusBadges.css";

// Renders a car's condition badge (damaged / good condition) and, separately,
// the "Inspected by Carexpress" badge. Both are optional — nothing renders when
// a car has neither. `compact` drops the icons for tight spots (e.g. the live
// auction queue). A value of 1/"1"/true counts as inspected.

const isInspected = (v) => v === 1 || v === "1" || v === true;

const CarStatusBadges = ({ car, lang = "geo", compact = false, className = "" }) => {
    if (!car) return null;
    const condition = String(car.condition_status || "").trim().toLowerCase();
    const cond = condition === "damaged" || condition === "good" ? condition : null;
    const inspected = isInspected(car.inspected);
    if (!cond && !inspected) return null;

    return (
        <div className={`car-status-badges ${compact ? "is-compact" : ""} ${className}`}>
            {cond && (
                <span className={`car-status-badge is-${cond}`}>
                    {!compact && (cond === "damaged" ? <ExclamationTriangleFill aria-hidden="true" /> : <PatchCheckFill aria-hidden="true" />)}
                    {conditionLabel(cond, lang)}
                </span>
            )}
            {inspected && (
                <span className="car-status-badge is-inspected">
                    {!compact && <ShieldCheck aria-hidden="true" />}
                    {inspectedLabel(lang)}
                </span>
            )}
        </div>
    );
};

export default CarStatusBadges;
